import { useRef, useState, useEffect } from 'react';
import { Chess } from 'chess.js';
import { Chessboard } from 'react-chessboard';
import { parse } from '@mliebelt/pgn-parser';
import { Link } from "react-router-dom";
import { useStopwatch } from 'react-timer-hook';

import '../style/Puzzle.scss';

import Rules from "../components/Rules";

import basicPgnFile from '../pgn/Normal.pgn';
import advancePgnFile from '../pgn/Advanced.pgn';
import masterPgnFile from '../pgn/Master.pgn';

import whitePawn from '../images/svg/white-pawn.svg';
import blackPawn from '../images/svg/black-pawn.svg';
import puzzlePlayed from '../images/svg/puzzle-played.svg';
import puzzlePlayedMenu from '../images/svg/puzzle-played-menu-icon.svg';
import star from '../images/svg/star.svg';
import right from '../images/svg/right.svg';
import wrong from '../images/svg/wrong.svg';
import hint from '../images/svg/hint.svg';
import arrows from '../images/svg/arrows.svg';
import close from '../images/svg/close.svg';
import closeBox from '../images/svg/close-1.svg';
import troffy from '../images/svg/troffy.svg';
import stopwatch from '../images/svg/stopwatch.svg';
import clock from '../images/svg/clock.svg';

export default function Puzzle() {
	
	const [popUpBox, setPopUpBox] = useState(null);
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	
	const chessboardRef = useRef();
	const [game, setGame] = useState(new Chess());
	
	const [moveFrom, setMoveFrom] = useState('');
	
	const [rightClickedSquares, setRightClickedSquares] = useState({});
	const [moveSquares, setMoveSquares] = useState({});
	const [optionSquares, setOptionSquares] = useState({});
	const [boardOrientation, setBoardOrientation] = useState('black');
	const [chessboardSize, setChessboardSize] = useState(undefined);
	
	const {
		seconds,
		minutes,
		hours,
		days,
		isRunning,
		start,
		pause,
		reset,
	} = useStopwatch({ autoStart: true });

	
	//const [pgnState, setPgnState] = useState([])
	const [pgnState, setPgnState] = useState(false);
	const [loading, setLoading] = useState(true);
	var gamePuzzle = [];
	//var readPuzzleMovesLength = "";
	const [puzzleMovesLengthValue, setPuzzleMovesLengthValue] = useState("");
	const [puzzleMovesLength, setPuzzleMovesLength] = useState("");
	const [puzzleIndex, setPuzzleIndex] = useState(0);
	const [moveIndex, setMoveIndex] = useState(0);
	const [opponentMoveIndex, setOpponentMoveIndex] = useState(1);
	/* var gamePuzzleFen = "";
	var gamePuzzleMoves = ""; */
	//const [playerMoveValue, setPlayerMoveValue] = useState("");
	const [playerMoves, setPlayerMoves] = useState("");
	//const [opponentMoveValue, setOpponentMoveValue] = useState("");
	//const [opponentMove, setOpponentMove] = useState("");
	const [colorMove, setColorMove] = useState("White");
	const [puzzleScore, setPuzzleScore] = useState(0);
	const [moveColor, setMoveColor] = useState(false);
	const [rightMove, setRightMove] = useState(false);
	const [rightMovePlus, setRightMovePlus] = useState(false);
	const [rightMoveCount, setRightMoveCount] = useState(0);
	const [wrongMove, setWrongMove] = useState(false);
	const [wrongMoveMinus, setWrongMoveMinus] = useState(false);
	const [wrongMoveCount, setWrongMoveCount] = useState(0);
	const [noPoint, setNoPoint] = useState(false);
	const [gamePuzzleMapping, setgamePuzzleMapping] = useState([]);
	const [scoreValue, setScoreValue] = useState(10);
	const [rightText, setRightText] = useState('You are awesome!');
	const [playedBox, setPlayedBox] = useState(false);
	const [gameOver, setGameOver] = useState(false);
	const [puzzlePLayedCount, setPuzzlePLayedCount] = useState(0);
	const [puzzleTitleName, setPuzzleTitleName] = useState("");
	var getPuzzleData = null;
	var getBasicPuzzleData = null;
	var getAdvancePuzzleData = null;
	var getMasterPuzzleData = null;
	var tempI = '';
	var successfulIndices = '';
	var failedIndices = '';
	//const [successfulIndicesMapping, setSuccessfulIndicesMapping] = useState("");
	//const [tempIMapping, setTempIMapping] = useState("");
	const [submitCorrectAnswerMappping, setSubmitCorrectAnswerMappping] = useState(null);
	const [submitWrongAnswerMappping, setSubmitWrongAnswerMappping] = useState(null);
	var submitCorrectAnswer = null;
	var submitWrongAnswer = null;
	//var checkUserMove = "";
	//const [puzzleAnswer, setPuzzleAnswer] = useState([]);
	var showInstructionOnce = null;
	var getLoginUserData = null;
	var loginUserEmail = '';
	var loginUserUid = '';
	const [showOne, setShowOne] = useState(false);
	const [loginState, setLoginState] = useState(true);
	const [puzzleIndexState, setPuzzleIndexState] = useState(true);
	const [zeroSecondsState, setZeroSecondsState] = useState(true);
	const [zeroMinutesState, setZeroMinutesState] = useState(true);
	
	const [getPuzzleDifficultyMapping, setGetPuzzleDifficultyMapping] = useState("");
	var getPuzzleDifficulty = "";
	var pgnFile;
	var queryString = '';
	
	const getQueryString = window.location.search;
	queryString = getQueryString;

	const getUserData = () => {

		if(queryString != ''){
			getLoginUserData = new URLSearchParams(queryString);
			loginUserUid = getLoginUserData.get('uid');
			loginUserEmail = getLoginUserData.get('email');
		} else{
			getLoginUserData = JSON.parse(localStorage.getItem("loginUserData"));
			console.log(getLoginUserData);
			if(getLoginUserData != null) {
				loginUserEmail = getLoginUserData.email;
				//console.log(loginUserEmail);
				loginUserUid = getLoginUserData.uid;
				//console.log(loginUserUid);
			}
		}

	}
	useEffect(() => {
		
		getUserData();
		
		if(queryString != ''){
			getPuzzleDifficulty = getLoginUserData.get('difficulty');
		} else{
			getPuzzleDifficulty = localStorage.getItem("puzzleDifficulty");
		}

		setGetPuzzleDifficultyMapping(getPuzzleDifficulty);
		
		const getData = async () => {
			try {
				const requestOptions = {
					method: 'POST'
				};
				const response = await fetch(
					'https://p1.squareoffnow.com/api/ichess?uid='+loginUserUid+'&email='+loginUserEmail+'&getAttempts=1&puzzleType='+getPuzzleDifficulty+'', requestOptions
				);
				if (!response.ok) {
					throw new Error(
					`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				//setData(actualData);
				setData(actualData);
				console.log('actualData - ' , actualData);
				console.log('actualData.failed - ' , actualData.failed);
				console.log('actualData.successful - ' , actualData.successful);
				
				successfulIndices = actualData.successful;
				console.log('successfulIndices - ', successfulIndices);
				failedIndices = actualData.failed;
				console.log('failedIndices - ', failedIndices);	
				fetchPgn();
				setError(null);
			} catch(err) {
				setError(err.message);
				setData(null);
			} 
		}
		if(getLoginUserData != null) {getData()}
	}, []);
	
	const fetchPgn = () =>{
		var index = 0;
		
		// console.log(queryString);
		if(queryString != ''){
			getLoginUserData = new URLSearchParams(queryString);
			getPuzzleDifficulty = getLoginUserData.get('difficulty');
			console.log('params run');
		} else{
			getPuzzleDifficulty = localStorage.getItem("puzzleDifficulty");
			console.log('params dont run');
		}
		
		setGetPuzzleDifficultyMapping(getPuzzleDifficulty);	
		
		if(getPuzzleDifficulty == 0){
			pgnFile = basicPgnFile;
			setPuzzleTitleName('Rookie Riddles');
			console.log(getPuzzleDifficulty);
			console.log('basic puzzle loaded');
		} else if(getPuzzleDifficulty == 1){
			pgnFile = advancePgnFile;
			setPuzzleTitleName("Knight's Attack");
			console.log(getPuzzleDifficulty);
			console.log('advance puzzle loaded');
		}  else if(getPuzzleDifficulty == 2){
			pgnFile = masterPgnFile;
			setPuzzleTitleName('Elite Enigmas');
			console.log(getPuzzleDifficulty);
			console.log('master puzzle loaded');
		}	
			
		fetch(pgnFile)
		.then(r => r.text())
		.then(pgn => {
			//console.log('pgn decoded:', pgn);
			let games = parse(pgn, {startRule: "games"});
			//setPgnState(games);
			//console.log(games);
			games.forEach((game) => {
				let gameMoves = game.moves;
				//console.log(gameMoves);
				let gameFen = game.tags.FEN;
				//console.log(gameFen);
				let gameColor = game.moves[0].turn;
				//console.log('gameColor', gameColor);
				var obj = {};
				obj.fen = gameFen;
				obj.color = gameColor;
				//obj.answer = 'ND';//failedIndices || successfulIndices = 1,3,5,
				
				tempI = ',' + index + ',';
				//setTempIMapping(tempI);
				//console.log('tempI - ', tempI);
				//console.log('failedIndices - ', failedIndices);
				//console.log('successfulIndices - ', successfulIndices);
				
				//new logic start
				if (failedIndices.includes(tempI)){
					obj.answer = 'wrong';
					//console.log('answer wrong indices working');
				}	
				else if(successfulIndices.includes(tempI)){
					obj.answer = 'correct';
					//console.log('answer right indices working');
				}	
				else{
					obj.answer = 'ND';
					//console.log('answer ND indices working');
				}	
				//end
				
				//console.log('obj.answer - ' , obj.answer);
				
				obj.moves = [];
				gameMoves.forEach((gameMove) => {
					let gameNotation = gameMove.notation.notation;
					//console.log(gameNotation);
					var objMove = obj.moves;
					objMove.push(gameNotation);
				});
				gamePuzzle.push(obj);
				
				index++;
			});
			
			console.log(gamePuzzle);
			
			//readPuzzleMovesLength = gamePuzzle[puzzleIndex].moves.length;
			//console.log("read gamepuzzle moves length - " , readPuzzleMovesLength);
			setPuzzleMovesLengthValue(gamePuzzle[puzzleIndex].moves.length);
			console.log("gamepuzzle moves length - " , puzzleMovesLengthValue);
			
			
			function getAllIndexes(arr, val) {
				var submitAnswer = [], i;
				for(i = 0; i < arr.length; i++)
					if (arr[i].answer === val)
						submitAnswer.push(i);
				return submitAnswer;
			}
			
			
			if(getPuzzleDifficulty == 0){
				getBasicPuzzleData = JSON.parse(localStorage.getItem("storeBasicPuzzleData"));
				console.log('basic puzzle loaded');
				//console.log('getBasicPuzzleData - ' , getBasicPuzzleData);
			} else if(getPuzzleDifficulty == 1){
				getAdvancePuzzleData = JSON.parse(localStorage.getItem("storeAdvancePuzzleData"));
				console.log('advance puzzle loaded');
				//console.log('getAdvancePuzzleData - ' , getAdvancePuzzleData);
			}  else if(getPuzzleDifficulty == 2){
				getMasterPuzzleData = JSON.parse(localStorage.getItem("storeMasterPuzzleData"));
				console.log('master puzzle loaded');
				//console.log('getMasterPuzzleData - ' , getMasterPuzzleData);
			}	
			
			
			console.log('getLoginUserData - ', getLoginUserData);
			console.log('loginState - ', loginState);
			
			if(getBasicPuzzleData == null && getPuzzleDifficulty == 0){
				setgamePuzzleMapping(gamePuzzle);
				console.log('gamePuzzleMapping = ', gamePuzzleMapping);
				getPuzzleIndex();
			} else if(getLoginUserData != null && loginState == true){
				setgamePuzzleMapping(gamePuzzle);
				console.log('gamePuzzleMapping = ', gamePuzzleMapping);
				setLoginState(false);
				getPuzzleIndex();
			} else if(getBasicPuzzleData != null && getPuzzleDifficulty == 0){
				setgamePuzzleMapping(getBasicPuzzleData);
				console.log('getBasicPuzzleData - ' , gamePuzzleMapping);
				const filteredPuzzlePlayedList = getBasicPuzzleData.filter( (e: any) => (e.answer != 'ND'));
				localStorage.setItem("storeBasicFilteredPuzzlePlayedList", filteredPuzzlePlayedList.length);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList.length);
				submitCorrectAnswer = getAllIndexes(getBasicPuzzleData, "correct");
				submitCorrectAnswer = submitCorrectAnswer.toString();
				setSubmitCorrectAnswerMappping(submitCorrectAnswer);
				submitWrongAnswer = getAllIndexes(getBasicPuzzleData, "wrong");
				submitWrongAnswer = submitWrongAnswer.toString();
				setSubmitWrongAnswerMappping(submitWrongAnswer);
				console.log('submitCorrectAnswer - ', submitCorrectAnswer);
				console.log('submitWrongAnswer - ', submitWrongAnswer);
				getPuzzleIndex();
			} else if(getAdvancePuzzleData == null && getPuzzleDifficulty == 1){
				setgamePuzzleMapping(gamePuzzle);
				console.log('gamePuzzleMapping = ', gamePuzzleMapping);
				getPuzzleIndex();
			} else if(getAdvancePuzzleData != null && getPuzzleDifficulty == 1){
				setgamePuzzleMapping(getAdvancePuzzleData);
				console.log('getAdvancePuzzleData - ' , gamePuzzleMapping);
				const filteredPuzzlePlayedList = getAdvancePuzzleData.filter( (e: any) => (e.answer != 'ND'));
				localStorage.setItem("storeAdvanceFilteredPuzzlePlayedList", filteredPuzzlePlayedList.length);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList.length);
				submitCorrectAnswer = getAllIndexes(getAdvancePuzzleData, "correct");
				submitCorrectAnswer = submitCorrectAnswer.toString();
				setSubmitCorrectAnswerMappping(submitCorrectAnswer);
				submitWrongAnswer = getAllIndexes(getAdvancePuzzleData, "wrong");
				submitWrongAnswer = submitWrongAnswer.toString();
				setSubmitWrongAnswerMappping(submitWrongAnswer);
				console.log('submitCorrectAnswer - ', submitCorrectAnswer);
				console.log('submitWrongAnswer - ', submitWrongAnswer);
				getPuzzleIndex();
			} else if(getMasterPuzzleData == null && getPuzzleDifficulty == 2){
				setgamePuzzleMapping(gamePuzzle);
				console.log('gamePuzzleMapping = ', gamePuzzleMapping);
				getPuzzleIndex();
			} else if(getMasterPuzzleData != null && getPuzzleDifficulty == 2){
				setgamePuzzleMapping(getMasterPuzzleData);
				console.log('getMasterPuzzleData - ' , gamePuzzleMapping);
				const filteredPuzzlePlayedList = getMasterPuzzleData.filter( (e: any) => (e.answer != 'ND'));
				localStorage.setItem("storeMasterFilteredPuzzlePlayedList", filteredPuzzlePlayedList.length);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList);
				console.log('filteredPuzzlePlayedList - ' , filteredPuzzlePlayedList.length);
				submitCorrectAnswer = getAllIndexes(getMasterPuzzleData, "correct");
				submitCorrectAnswer = submitCorrectAnswer.toString();
				setSubmitCorrectAnswerMappping(submitCorrectAnswer);
				submitWrongAnswer = getAllIndexes(getMasterPuzzleData, "wrong");
				submitWrongAnswer = submitWrongAnswer.toString();
				setSubmitWrongAnswerMappping(submitWrongAnswer);
				console.log('submitCorrectAnswer - ', submitCorrectAnswer);
				console.log('submitWrongAnswer - ', submitWrongAnswer);
				getPuzzleIndex();
			}
				
			
			
			//playerMoveValue = gamePuzzle[puzzleIndex].moves[moveIndex];
			//setPlayerMoveValue(gamePuzzle[puzzleIndex].moves[moveIndex]);
			//console.log(playerMoveValue);
			//setOpponentMoveValue(gamePuzzle[puzzleIndex].moves[opponentMoveIndex]);
			//console.log(opponentMoveValue);
			
			console.log('newPuzzleIndex' , puzzleIndex);
			game.load(gamePuzzle[puzzleIndex].fen);
			console.log('gameFen' , game.fen());
			
			colorToMove();
			//addPuzzleAnswer();
			//puzzleHint();
			/* if(checkUserMove == playerMoves && (checkUserMove.length > 0 && playerMoves.length > 0)){
				indexPlus();
				console.log('plus working');
			} else{
				indexSame();
				console.log('same working');
			} */
			puzzlesPlayed();
			
			showInstructionOnce = localStorage.getItem("setShowInstructionOnce");
			//if(getBasicPuzzleData == null && getAdvancePuzzleData == null && getMasterPuzzleData == null && showInstructionOnce == true){
			if(showInstructionOnce == null){
				setPopUpBox(true);
			} else{
				setPopUpBox(false);
				setShowOne(true);
				setTimeout(function () {
					setLoading(false);
					setPgnState(true);
					//reset(); //stopwatch time reset function
				}, 2000);
			}
			
		});
	};
	useEffect(() => {
		
		if(getLoginUserData == null) {fetchPgn();}
		
		function handleResize() {
			const display = document.getElementsByClassName('puzzle-board')[0];
			//setChessboardSize(display.offsetWidth - 20);
			setChessboardSize(display.offsetWidth);
		}
	
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => window.removeEventListener('resize', handleResize);
	}, [puzzleIndex]);
	
	
	const getPuzzleIndex = () => {
		if(puzzleIndexState){
			function getAllIndexes(arr, val) {
				var submitAnswer = [], i;
				for(i = 0; i < arr.length; i++)
					if (arr[i].answer === val)
						submitAnswer.push(i);
				return submitAnswer;
			}
			if(gamePuzzleMapping.length == 0){
				var getNotDoneIndex = getAllIndexes(gamePuzzle, "ND");
			} else{
				var getNotDoneIndex = getAllIndexes(gamePuzzleMapping, "ND");
			}
			console.log('getPuzzleIndexpre -' , puzzleIndex);
			console.log('getNDIndex -' , getNotDoneIndex[0]);
			setPuzzleIndex(getNotDoneIndex[0]);
			console.log('getPuzzleIndexpost -' , puzzleIndex);
			setPuzzleIndexState(false);
		}
	}
	
	const addZeroTimer = () => {
		if(seconds < 10){
			setZeroSecondsState(true);
			//console.log('seconds less than 10 ');
		} else{
			setZeroSecondsState(false);
			//console.log('seconds greater than 10 ');
		}
		
		if(minutes < 10){
			setZeroMinutesState(true);
			//console.log('minutes less than 10 ');
		} else{
			setZeroMinutesState(false);
			//console.log('minutes greater than 10 ');
		}
	}
	useEffect(() => {
		addZeroTimer();
	});
	
	const closePopUp = () => {
		setPopUpBox(false);
		setShowOne(true);
		setTimeout(function () {
			setLoading(false);
			setPgnState(true);
			reset(); //stopwatch time reset function
		}, 2000);
		localStorage.setItem('setShowInstructionOnce', '1');
	}
	
	function colorToMove () {
		var colorMove = gamePuzzle[puzzleIndex].color;
		console.log(colorMove);
		if (colorMove == 'w') { 
			setColorMove('White');
			setBoardOrientation('white');
			setMoveColor(false);
			console.log("white to move");
		} else{
			setColorMove('Black');
			setBoardOrientation('black');
			setMoveColor(true);
			console.log("black to move");
		}
	}
	
	const indexPlus = () => {
		if(puzzleIndex <= gamePuzzleMapping.length-2){
			setPuzzleIndex(puzzleIndex + 1);
			console.log('plus puzzleIndex' , puzzleIndex);
			console.log('gamePuzzleMapping.length' , gamePuzzleMapping.length-1);
		}
	};
	
	const indexSame = () => {
		setPuzzleIndex(puzzleIndex);
		console.log('same puzzleIndex' , puzzleIndex);
	};
	
	const movePlus = () => {
		setOpponentMoveIndex(opponentMoveIndex+2);
		console.log('opponent move plus - ' + opponentMoveIndex);
		setMoveIndex(moveIndex+2);
		console.log('move plus - ' + moveIndex);
	};
	
	const moveSame = () => {
		setOpponentMoveIndex(opponentMoveIndex);
		console.log('opponent move plus - ' + opponentMoveIndex);
		setMoveIndex(moveIndex);
		console.log('move plus - ' + moveIndex);
	};
	
	const moveReset = () => {
		setOpponentMoveIndex(1);
		console.log('opponent move reset - ' + opponentMoveIndex);
		setMoveIndex(0);
		console.log('move reset - ' + moveIndex);
	};
	
	const scorePlus = () => {
		if (seconds <= 10){
			setPuzzleScore(puzzleScore + 10);
			setScoreValue(10);
		} else if (seconds > 10 && seconds <= 15){
			setPuzzleScore(puzzleScore + 8);
			setScoreValue(8);
		} else if(seconds > 15){
			setPuzzleScore(puzzleScore + 5);
			setScoreValue(5);
		}
		setRightMoveCount(rightMoveCount+1);
		console.log('right move count - ' + rightMoveCount);
		totalPuzzlePLayed();
	};
	
	const scoreMinus = () => {
		if(puzzleScore < '5'){
			setPuzzleScore(0);
		} else{
			setPuzzleScore(puzzleScore - 5);
		}
		setWrongMoveCount(wrongMoveCount+1);
		console.log('wrong move count - ' + wrongMoveCount);
		totalPuzzlePLayed();
	};
	
	const totalPuzzlePLayed = () => {
		setPuzzlePLayedCount((rightMoveCount+wrongMoveCount)+1);
		console.log(puzzlePLayedCount);
	}
	
	const showRight = () => {
		setRightMove(true);
		setWrongMove(false);
		setTimeout(function () {
			setRightMove(false);
		}, 1500);
	};
	
	const showRightPlus = () => {
		setRightMovePlus(true);
		setWrongMoveMinus(false);
		setTimeout(function () {
			setRightMovePlus(false);
		}, 1500);
	};
	
	const showWrong = () => {
		setWrongMove(true);
		setRightMove(false);
		setTimeout(function () {
			setWrongMove(false);
		}, 1500);
	};
	
	const showWrongMinus = () => {
		setWrongMoveMinus(true);
		setRightMovePlus(false);
		setTimeout(function () {
			setWrongMoveMinus(false);
		}, 1500);
	};
	
	const opengameOver = () => {
		setGameOver(true);
	
		getUserData();
	
		console.log('submitWrongAnswerMappping - ', submitWrongAnswerMappping);
		console.log('submitCorrectAnswerMappping - ', submitCorrectAnswerMappping);
	
		const sendData = async () => {
			try {
				const requestOptions = {
					method: 'POST'
				};
				const response = await fetch(
					'https://p1.squareoffnow.com/api/ichess?uid='+loginUserUid+'&email='+loginUserEmail+'&setAttempts=1&puzzleType='+getPuzzleDifficultyMapping+'&failed=,'+submitWrongAnswerMappping+'&successful=,'+submitCorrectAnswerMappping+'', requestOptions
				);
				if (!response.ok) {
					throw new Error(
					`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				//setData(actualData);
				setData(actualData);
				console.log('actualData - ' , actualData);
				setError(null);
			} catch(err) {
				setError(err.message);
				setData(null);
			} 
		}
		if(getLoginUserData != null && submitWrongAnswerMappping != null && submitCorrectAnswerMappping != null ) {sendData()}
	}
	
	const openPlayedBox = () => {
		setPlayedBox(true);
	}
	
	const closePlayedBox = () => {
		setPlayedBox(false);
	}
	
	const handler = (index) => {
		setPuzzleIndex(index);
		setPlayedBox(false);
		setNoPoint(false);
		moveReset();
		reset(); //stopwatch time reset function
	};
	
	function puzzleHint() {
		var hintMoves = gamePuzzleMapping[puzzleIndex].moves[moveIndex];
		console.log('MhintMoves - ' + hintMoves);
		
		addPuzzleAnswer(puzzleIndex,'wrong');
		if(noPoint != true){
			setWrongMoveCount(wrongMoveCount+1);
		}
		setNoPoint(true);
		console.log('wrong move count - ' + wrongMoveCount);
		
		var moveFen = game.fen();
		var hintSquare = game.move(hintMoves);
		if(moveIndex == 0){
			game.load(gamePuzzleMapping[puzzleIndex].fen);
		} else{
			game.load(moveFen);
		}
		
		console.log('hintSquare - ', hintSquare);
		
		const newSquares = {};
		newSquares[hintSquare.from] = {
			background: 'rgba(80, 180, 236, 0.9)'
		};
		setOptionSquares(newSquares);
	}
	
	/* const addPuzzleAnswer = () => {
		setPuzzleAnswer(current => [...current]);	
		console.log('puzzleAnswer = ', puzzleAnswer);
		if(puzzleAnswer.length > 0){
			console.log('puzzleAnswer = ', puzzleAnswer[puzzleIndex-1].answer);
		}
		
		puzzleAnswer.map(move => {
			console.log('move answer - ' , move.answer);
		});
		
	};
	
	const addPuzzleAnswerRight = () => {
		setPuzzleAnswer(current => [...current, {answer: 'C'}]);
		console.log('puzzleAnswer = ', puzzleAnswer);
	};
	
	const addPuzzleAnswerWrong = () => {
		setPuzzleAnswer(current => [...current, {answer: 'W'}]);
					console.log('puzzleAnswer = ', puzzleAnswer);
	}; */
	
	const addPuzzleAnswer = (puzzleIndex,correctAns) => {
		//setgamePuzzleMapping(current => [...current, {answer: correctAns}]);
		
		const newgamePuzzleMapping = gamePuzzleMapping.map((played, index) => {
			if (index == puzzleIndex){
				return {...played, answer: correctAns}
			}
			return played
			console.log('played = ', puzzleIndex)
		});
		
		setgamePuzzleMapping(newgamePuzzleMapping);
		
		/* for(var i = 0; i < newgamePuzzleMapping.length; ++i){
			console.log('loop is working');
			//console.log(newgamePuzzleMapping[i].answer);
			//console.log(newgamePuzzleMapping[i].answer.length);
			if(newgamePuzzleMapping[i].answer == 'correct'){
				setPuzzlePLayedCount1(newgamePuzzleMapping[i].answer.length);
				console.log('puzzlePLayedCount1 = ', puzzlePLayedCount1);
			}
		} */
		
		if(getPuzzleDifficultyMapping == 0){
			localStorage.setItem("storeBasicPuzzleData", JSON.stringify(newgamePuzzleMapping));
			console.log(getPuzzleDifficultyMapping);
			console.log('basic puzzle loaded');
		} else if(getPuzzleDifficultyMapping == 1){
			localStorage.setItem("storeAdvancePuzzleData", JSON.stringify(newgamePuzzleMapping));
			console.log(getPuzzleDifficultyMapping);
			console.log('advance puzzle loaded');
		}  else if(getPuzzleDifficultyMapping == 2){
			localStorage.setItem("storeMasterPuzzleData", JSON.stringify(newgamePuzzleMapping));
			console.log(getPuzzleDifficultyMapping);
			console.log('master puzzle loaded');
		}	
		
		
		console.log('puzzleAnswer = ', gamePuzzleMapping);
	};
	
	function safeGameMutate(modify) {
		setGame((g) => {
			const update = { ...g };
			modify(update);
			return update;
		});
	}
	
	function getMoveOptions(square) {
		const moves = game.moves({
			square,
			verbose: true
		});
		if (moves.length === 0) {
			return;
		}
	
		const newSquares = {};
		moves.map((move) => {
			newSquares[move.to] = {
				background:
				game.get(move.to) && game.get(move.to).color !== game.get(square).color
					? 'radial-gradient(circle, rgba(0,0,0,.1) 85%, transparent 85%)'
					: 'radial-gradient(circle, rgba(0,0,0,.1) 25%, transparent 25%)',
				borderRadius: '50%'
			};
			return move;
		});
		newSquares[square] = {
			background: 'rgba(255, 255, 0, 0.4)'
		};
		setOptionSquares(newSquares);
	}
	
	function makeRandomMove() {
		//const possibleMoves = game.moves();
		const possibleMoves = gamePuzzleMapping[puzzleIndex].moves[opponentMoveIndex];
		console.log('possibleMoves - ', possibleMoves);
		console.log(gamePuzzleMapping[puzzleIndex]);
		console.log(puzzleIndex);
		
	
		// exit if the game is over
		//if (game.game_over() || game.in_draw() || possibleMoves.length === 0) return console.log('game over');
	
		//const randomIndex = Math.floor(Math.random() * possibleMoves.length);
		safeGameMutate((game) => {
			//game.move(possibleMoves[randomIndex]);
			//console.log(possibleMoves[randomIndex]);
			game.move(possibleMoves);
		});
	}
	
	function onSquareClick(square) {
		setRightClickedSquares({});
		
		//setPlayerMoves(playerMoveValue);
		setPlayerMoves(gamePuzzleMapping[puzzleIndex].moves[moveIndex]);
		console.log('playerMoves1 - ' + playerMoves);
		console.log(opponentMoveIndex);
		console.log(moveIndex);
		console.log(puzzleIndex);
		
		setPuzzleMovesLength(puzzleMovesLengthValue);
		console.log("gamepuzzle moves length - " , puzzleMovesLength);
		
		function resetFirstMove(square) {
			setMoveFrom(square);
			getMoveOptions(square);
		}
	
		// from square
		if (!moveFrom) {
			resetFirstMove(square);
			return;
		}
	
		// attempt to make move
		const gameCopy = { ...game };
		const move = gameCopy.move({
			from: moveFrom,
			to: square,
			promotion: 'q' // always promote to a queen for example simplicity
		});
		setGame(gameCopy);
		
		console.log(move);
		//setCheckUserMove(move.san);
		//checkUserMove = move.san;
		//console.log(checkUserMove);
	
		// if invalid, setMoveFrom and getMoveOptions
		if (move === null) {
			resetFirstMove(square);
			return;
		}
	
		
		if (puzzleMovesLength <= 2){
			if(move.san == playerMoves){
				if(noPoint != true){
					scorePlus();
					showRightPlus();
					addPuzzleAnswer(puzzleIndex,'correct');
				}
				setNoPoint(false);
				showRight();
				console.log(playerMoves);
				console.log(move.san);
				console.log('right move');
				setTimeout(indexPlus, 500);
				reset(); //stopwatch time reset function
				console.log('puzzleIndex - ' , puzzleIndex);
				//setTimeout(fetchPgn, 600);
			} else{
				if(noPoint != true){
					scoreMinus();
					showWrongMinus();
					addPuzzleAnswer(puzzleIndex,'wrong');
				}
				setNoPoint(true);
				showWrong();
				console.log(playerMoves);
				console.log(move.san);
				console.log('wrong move');
				setTimeout(indexSame, 500);
				console.log('puzzleIndex - ' , puzzleIndex);
				setTimeout(fetchPgn, 600);
			}
			console.log('single move puzzle');
		} else{
			//setTimeout(makeRandomMove, 300);
			if (opponentMoveIndex <= puzzleMovesLength-2){
				if(move.san == playerMoves){
					movePlus();
					showRight();
					setRightText('Right move');
					console.log(playerMoves);
					console.log(move.san);
					console.log('right move');
					setTimeout(makeRandomMove, 300);
				} else{
					if(noPoint != true){
						scoreMinus();
						showWrongMinus();
						addPuzzleAnswer(puzzleIndex,'wrong');
					}
					setNoPoint(true);
					showWrong();
					moveReset();
					console.log(playerMoves);
					console.log(move.san);
					console.log('wrong move!');
					setTimeout(indexSame, 500);
					console.log('puzzleIndex - ' , puzzleIndex);
					setTimeout(fetchPgn, 600);
				}
				console.log('go');
			} else{
				if(move.san == playerMoves){
					if(noPoint != true){
						scorePlus();
						showRightPlus();
						addPuzzleAnswer(puzzleIndex,'correct');
					}
					setNoPoint(false);
					showRight();
					setRightText('You are awesome!');
					console.log(playerMoves);
					console.log(move.san);
					console.log('right move');
					moveReset();
					setTimeout(indexPlus, 500);
					reset(); //stopwatch time reset function
				} else{
					if(noPoint != true){
						scoreMinus();
						showWrongMinus();
						addPuzzleAnswer(puzzleIndex,'wrong');
					}
					setNoPoint(true);
					showWrong();
					moveReset();
					console.log(playerMoves);
					console.log(move.san);
					console.log('wrong move');
					setTimeout(indexSame, 500);
					console.log('puzzleIndex - ' , puzzleIndex);
					setTimeout(fetchPgn, 600);
				}
				
				//setTimeout(fetchPgn, 600);
				console.log('no go');
			}
			console.log('multiple move puzzle');
		}
		
		
		
		setMoveFrom('');
		setOptionSquares({});
	}
	
	function puzzlesPlayed() {
		var puzzleLength = gamePuzzle.length;
		console.log('puzzle length - ' + puzzleLength);
	}
	
	function onSquareRightClick(square) {
		const colour = 'rgba(0, 0, 255, 0.4)';
		setRightClickedSquares({
			...rightClickedSquares,
			[square]:
				rightClickedSquares[square] && rightClickedSquares[square].backgroundColor === colour
				? undefined
				: { backgroundColor: colour }
		});
	}
	
	return (
		<div className="container puzzle">
			
			<div className={'rules-overlay popup-overlay' + (popUpBox  ? '' : ' hide')}>
				<Rules closePopUp={closePopUp} />
			</div>
		
			<div className="puzzle-header">
				<div className="puzzle-header-sub">
					<img onClick={() => opengameOver()} src={close} className="puzzle-close-svg" alt="icon" />
					<p className="puzzle-played-count"> <img src={puzzlePlayed} className="puzzle-played-count-img" alt="icon" /> {puzzleIndex+1} / {gamePuzzleMapping.length}</p>
					<img src={puzzlePlayedMenu} onClick={() => openPlayedBox()} className="puzzle-played-count-click" alt="icon" />
					
					<div className={'puzzle-played-overlay' + (playedBox ? '' : ' hide')}>
						<div className="puzzle-played-flex">
							<div className="puzzle-played-count-close-box hide-on-desktop">
								<img src={closeBox} onClick={() => closePlayedBox()} className="puzzle-played-count-close" alt="icon" />
							</div>
							<div className="puzzle-played-box">
								{pgnState && gamePuzzleMapping.map((played, index) => (
									<div key={index} onClick={() => handler(index)} className={'puzzle-played-circle' + ' '+played.answer+''}>{index + 1}</div>
								))}
							</div>
							<div className="puzzle-played-circle-help-overlay">
								<div className="puzzle-played-circle-help-box">
									<div className="puzzle-played-circle-help-sub wrong"></div>
									<p className="puzzle-played-circle-help-text">Wrong</p>
								</div>
								<div className="puzzle-played-circle-help-box">
									<div className="puzzle-played-circle-help-sub correct"></div>
									<p className="puzzle-played-circle-help-text">Correct</p>
								</div>
								<div className="puzzle-played-circle-help-box">
									<div className="puzzle-played-circle-help-sub"></div>
									<p className="puzzle-played-circle-help-text">Not Attempted</p>
								</div>
								<img src={closeBox} onClick={() => closePlayedBox()} className="puzzle-played-count-close hide-on-mobile" alt="icon" />
							</div>
						</div>		
					</div>		
				</div>
			</div>
			
			{loading && <div className="lets-go-box">
				<img src={stopwatch} className="stopwatch-svg" alt="" />
				<p className={showOne ? 'animate' : ''}>3</p>
				<p className={showOne ? 'animate' : ''}>2</p>
				<p className={showOne ? 'animate' : ''}>1</p>
			</div>}
			
			<div className="content-box">
				<div className="puzzle-overlay">			
					{pgnState && <div className={'puzzle-info-right-side op0' + (loading ? '' : ' showTransition')}>
						<div className="puzzle-color-move-overlay posr">
							<div className="puzzle-color-move-box posr" style={{backgroundColor: moveColor ? '#000' : '#fff'}}>
								<div className="puzzle-color-move-sub">
									<img src={moveColor ? blackPawn : whitePawn} className="white-pawn-svg" alt="icon" />
									<p className="color-move-text" style={{color: moveColor ? '#fff' : '#000'}}>{colorMove} to move</p>
								</div>
								{/* <img src={arrows} className="arrows-svg" style={{filter: moveColor ? 'invert(1)' : 'initial'}} alt="icon" /> */}
							</div>
							<div className={'puzzle-right-box' + (rightMove ? ' active' : '')}>
								<div className="puzzle-right-wrong-flex">
									<div className="puzzle-right-sub">
										<img src={right} className="right-svg" alt="icon" />
										<p className="color-right-text">{rightText}</p>
									</div>
								</div>
							</div>
							<div className={'puzzle-wrong-box' + (wrongMove ? ' active' : '')}>
								<div className="puzzle-right-wrong-flex">
									<div className="puzzle-wrong-sub">
										<img src={wrong} className="wrong-svg" alt="icon" />
										<p className="color-wrong-text">Wrong move!</p>
									</div>
								</div>
							</div>
						</div>
						<div className="puzzle-info-overlay">
							<div className="wdh">
								<div className="puzzle-score-overlay">
									<div className="puzzle-score-box">
										<p className="puzzle-score-text">
											<img src={star} className="star-svg" alt="icon" /> 
											{puzzleScore} 
											<span className={'puzzle-score-span' + (rightMovePlus ? '' : ' hide')}>+{scoreValue}</span>
											<span className={'puzzle-score-span' + (wrongMoveMinus ? '' : ' hide')}>-5</span>
											<span className={'puzzle-score-span' + (noPoint ? '' : ' hide')}>unrated</span>
										</p>
									</div>
									<div className="puzzle-timer-box">
										<p className="puzzle-timer-text"> <img src={clock} className="clock-svg" alt="icon" /> <span>{zeroMinutesState ? '0' : ''}{minutes}</span> : <span style={{marginLeft:'3px'}}>{zeroSecondsState ? '0' : ''}{seconds}</span></p>
									</div>
								</div>
							</div>	
							<div className="puzzle-hint-overlay">
								<p onClick={() => puzzleHint()} className="puzzle-hint-text"><img src={hint} className="hint-svg" alt="icon" /> Hint</p>
							</div>
						</div>
					</div>}
					<div className={'puzzle-board op0' + (loading ? '' : ' showTransition')}>
					{pgnState && <Chessboard
							id="Puzzle"
							animationDuration={200}
							boardOrientation={boardOrientation}
							arePiecesDraggable={false}
							boardWidth={chessboardSize}
							position={game.fen()}
							onSquareClick={onSquareClick}
							onSquareRightClick={onSquareRightClick}
							customBoardStyle={{
							borderRadius: '4px'
							// boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
							}}
							customSquareStyles={{
							...moveSquares,
							...optionSquares,
							...rightClickedSquares
							}}
							// customDarkSquareStyle={{ backgroundColor: '#9E9FA1' }}
							// customLightSquareStyle={{ backgroundColor: '#C3C3C3' }}
							customDarkSquareStyle={{ backgroundColor: '#c9c9c9' }}
							customLightSquareStyle={{ backgroundColor: '#f2f2f2' }}
							ref={chessboardRef}
						/>}
					</div>
				</div>	
			</div>
			
			<div className={'game-over-overlay' + (gameOver ? '' : ' hide')}>
				<div className="game-over-flex">
					<div className={'game-over-box' + (gameOver ? ' animate' : '')}>
						<h3 className="game-over-title">{puzzleTitleName}</h3>
						<img src={troffy} className="troffy-svg" alt="icon" />
						<h2 className="final-score-text"><img src={star} className="star-svg" alt="icon" /> {puzzleScore}</h2>
						<div className="puzzle-count-box">
							<div className="puzzle-count-sub">
								<p className="puzzle-count-title">Right</p>	
								<h3 className="puzzle-count-number">{rightMoveCount}</h3>	
							</div>
							<div className="puzzle-count-sub">
								<p className="puzzle-count-title">Unrated</p>	
								<h3 className="puzzle-count-number">{wrongMoveCount}</h3>	
							</div>
							<div className="puzzle-count-sub">
								<p className="puzzle-count-title">Total</p>	
								<h3 className="puzzle-count-number">{puzzlePLayedCount}</h3>	
							</div>
						</div>
						<div className="game-over-anchor-box">
							{queryString == '' ? <Link className="go-to-home-anchor" to="/">Go to Home</Link> : <a className="go-to-home-anchor" href="https://squareoffnow.com/apps/back" rel="noopener noreferrer">Go Home</a>}
						</div>
					</div>
				</div>
			</div>
			
		</div>
	);
	
}